export const environment = {
    production: true,
    api: 'https://sicapi.cdd.com.br/api/',
    totalResultPage: 10,
    appVersion: require('../../package.json').version,
};
